export const avatarState = {
  height: 0.9,
  shirt: true,
  pants: true,
  shoes: true,
  beard: true,
  topHair: true,
  sideHair: true,
  rightPocket: true,
  leftPocket: true,
  buttons: true,
  belt: true,
  skinColor: {hex8: "#daad7fff"},
  skinColor2: {hex8: "#d28d5fff"},
  lipsColor: {hex8: "#d28d5fff"},
  shirtColor: {hex8: "#333333ff"},
  armSleeveColor: {hex8: "#333333ff"},
  pantsColor: {hex8: "#939393ff"},
  pantsLegColor: {hex8: "#939393ff"},
  shoeColor: {hex8: "#222222ff"},
  beardColor: {hex8: "#6d5542ff"},
  hairColor: {hex8: "#6d5542ff"},
  hairSideColor: {hex8: "#6d5542ff"},
  beltColor: {hex8: "#111111ff"},
  pocketColor: {hex8: "#44444440" },
  armSleeveLengthPercent: 95 / 100,
  shirtLengthPercent: 100 / 100,
  pantsLegLengthPercent: 100 / 100,
  pantsFit: 0,
  happiness: 5,
};